import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ImagesRoutingModule } from './images-routing.module';
import { ImagesComponent } from './images.component';
import { CommonFileUploadModule } from 'src/app/global/common-file-upload/common-file-upload.module';
import { CommonImagesModule } from '../../common-images/common-images.module';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [
    ImagesComponent
  ],
  imports: [
    CommonModule,
    ImagesRoutingModule,
    CommonFileUploadModule,
    CommonImagesModule,
    SharedModule

  ],exports:[
    ImagesComponent
  ]
})
export class ImagesModule { }
